export enum NotificationDestination {
  EMAIL = "EMAIL",
  SMS = "SMS",
}

export type TNotificationDestination = `${NotificationDestination}`;
